import React, { Component } from 'react'

class MenuHeading extends Component {
    constructor(props) {
        super(props);

        this.state = {}
    }

    render() {
        return (
            <span key={this.props.key} className="menuHeading" style={{ width: this.props.small === true ? 150 : 200, paddingTop: this.props.small === true ? 10 : 30, paddingLeft: this.props.small === true ? 5 : 10, paddingRight: this.props.small === true ? 5 : 10, paddingBottom: this.props.small === true ? 5 : 10, }} >{this.props.text}</span>
        );
    }
}

export default MenuHeading


// WEBPACK FOOTER //
// ./src/components/Menu/MenuHeading.js